import type { TenantConfig } from '@/types/TenantConfig'

export const jurassicquestcanada: TenantConfig = {
  logo: 'assets/jurassicquestcanada/static/logo.png',
  teaserImageSize: {
    height: 200,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap',
    },
    selectDate: {
      hideTodayTomorrowButtons: true,
    },
  },
}
